/**
 * Human label for a farm LP symbol.
 *
 * Upstream PancakeSwap strips its own brand prefix ("Pancake USDT-BNB LP" -> "USDT-BNB LP").
 * The fork had replaced that regex with /cadinu/gi, which also deleted the CADINU *token*
 * symbol ("USDT-CADINU LP" -> "USDT- LP"). Only a brand prefix is stripped here; a token
 * symbol is never touched.
 */
export const getLpLabel = (lpSymbol?: string): string | undefined =>
  lpSymbol ? lpSymbol.replace(/^\s*(pancake|cadinu)\s+/i, '').replace(/pancake/gi, '') : lpSymbol
